"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecaptchaErrorModal = exports.RecaptchaModal = void 0;
var RecaptchaModal_1 = require("./RecaptchaModal");
Object.defineProperty(exports, "RecaptchaModal", { enumerable: true, get: function () { return __importDefault(RecaptchaModal_1).default; } });
var RecaptchaErrorModal_1 = require("./RecaptchaErrorModal");
Object.defineProperty(exports, "RecaptchaErrorModal", { enumerable: true, get: function () { return __importDefault(RecaptchaErrorModal_1).default; } });
//# sourceMappingURL=index.js.map